import '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';

const mapServerToSpecificationsBase = (serverVariant, brand, locale)=>{
    const { erpId , opcoBackendId , sku , variantTypeDetails  } = serverVariant;
    let brandModel, brandModelCode, faceShape, templeColor;
    if ((variantTypeDetails === null || variantTypeDetails === void 0 ? void 0 : variantTypeDetails.__typename) === 'SunglassesVariantTypeDetails' || (variantTypeDetails === null || variantTypeDetails === void 0 ? void 0 : variantTypeDetails.__typename) === 'FrameVariantTypeDetails') {
        var ref;
        var _brandModel;
        brandModel = (_brandModel = variantTypeDetails.brandModel) !== null && _brandModel !== void 0 ? _brandModel : undefined;
        var _brandModelCode;
        brandModelCode = (_brandModelCode = variantTypeDetails.brandModelCode) !== null && _brandModelCode !== void 0 ? _brandModelCode : undefined;
        // Extract face shape values for the current locale
        const faceShapeValues = variantTypeDetails.faceShape.map((faceShapeItem)=>{
            // Find all localized names that match the current locale
            const matchingLocales = faceShapeItem.displayNameAllLocales.filter((localeItem)=>localeItem.locale === locale
            ).map((localeItem)=>localeItem.value
            ).filter(Boolean);
            return matchingLocales;
        })// Only keep face shapes that have matching locales
        .filter((values)=>values.length > 0
        ).flat();
        faceShape = faceShapeValues.length > 0 ? faceShapeValues.join(', ') : undefined;
        var ref1;
        templeColor = (ref1 = (ref = variantTypeDetails.frameFeatures) === null || ref === void 0 ? void 0 : ref.templeColor) !== null && ref1 !== void 0 ? ref1 : undefined;
    }
    const serverSpecifications = {
        brand,
        erpId,
        opcoBackendId,
        sku,
        brandModel,
        brandModelCode,
        faceShape,
        templeColor
    };
    return getSpecificationItems(serverSpecifications);
};

export { mapServerToSpecificationsBase };
//# sourceMappingURL=map-server-to-specifications-base.js.map
